import React from 'react'
import styled, { css } from 'styled-components'
import ParseContent from 'components/shared/ParseContent'
import ButtonSlide from 'components/elements/ButtonSlide'
import Plaatjie from '@ubo/plaatjie'
import Img from 'gatsby-image'

const ImgCSS = css`
  height: 100%;
  position: absolute !important;
  bottom: 0;
  right: 0;
  left: 0;

  & img {
    object-fit: contain !important;
  }
`

const StyledImg = styled(Img)`
  ${ImgCSS};
`

const StyledPlaatjie = styled(Plaatjie)`
  ${ImgCSS};
`

const StyledDownloadBrochure = styled.section`
  position: relative;
  z-index: 1;
  padding-top: 30px;
  padding-bottom: 30px;

  @media screen and (max-width: 991px) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`

const StyledContainer = styled.div`
  height: 100%;

  @media screen and (max-width: 991px) {
    height: unset;
    position: relative;
  }
`

const Wrapper = styled.div`
  background-color: ${(props) => props.theme.color.face.light};
  border-radius: 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: row;

  @media screen and (min-width: 992px) {
    padding: 60px 60px 60px 60px;
    gap: 30px;
  }

  @media screen and (max-width: 991px) {
    flex-direction: column;
    padding: 40px 24px;
    gap: 24px;
  }
`

const TextColumn = styled.div`
  @media screen and (min-width: 992px) {
    width: 60%;
    flex-shrink: 0;
  }

  @media screen and (max-width: 991px) {
    width: 100%;
  }

  & h2 {
    font-weight: ${(props) => props.theme.font.weight.xl};

    @media screen and (min-width: 992px) {
      font-size: ${(props) => props.theme.font.size.xl};
    }

    @media screen and (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.l};
    }
  }
`

const ButtonBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  @media screen and (max-width: 575px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const ButtonWrapper = styled.div`
  @media screen and (max-width: 575px) {
    width: 100%;

    & > * {
      width: 100%;
      display: block;
      text-align: center;
    }
  }
`

const Microcopy = styled.div`
  font-size: ${(props) => props.theme.font.size.s};
  color: ${(props) => props.theme.color.text.dark};

  @media screen and (max-width: 575px) {
    align-self: center;
    text-align: center;
  }
`

const ImageColumn = styled.div`
  position: relative;

  @media screen and (min-width: 992px) {
    width: 40%;
    flex-shrink: 0;
    min-height: 280px;
    margin-top: -60px;
    align-self: flex-start;
    border-radius: 12px;
  }

  @media screen and (max-width: 991px) {
    width: 100%;
    order: -1;
    border-radius: 12px;
    min-height: 200px;

    & > * {
      width: 100%;
      height: 100%;
    }

    & img {
      width: 100%;
      height: 100%;
    }
  }
`

const DownloadBrochure = ({ className = '', content, id = 'download-brochure' }) => {
  if (!content) return null
  return (
    <StyledDownloadBrochure id={id} className={`${className}`}>
      <StyledContainer className="container">
        <Wrapper>
          <TextColumn>
            <h2>{content?.title}</h2>
            <ParseContent
              className="mt-3"
              content={content?.description}
              compactLineHeight
            />
            <ButtonBlock className="mt-4">
              <ButtonWrapper>
                <ButtonSlide icon="arrow" to={content?.link?.url} defaultSize>
                  {content?.link?.title}
                </ButtonSlide>
              </ButtonWrapper>
              <Microcopy>{content?.microcopy}</Microcopy>
            </ButtonBlock>
          </TextColumn>
          <ImageColumn>
            {!!content.image?.localFile?.childImageSharp?.fluid ? (
              <StyledImg
                fluid={content.image.localFile.childImageSharp.fluid}
                objectFit="contain"
              />
            ) : (
              <StyledPlaatjie image={content.image} objectFit="contain" />
            )}
          </ImageColumn>
        </Wrapper>
      </StyledContainer>
    </StyledDownloadBrochure>
  )
}

export default DownloadBrochure
